import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class LookAttachment extends Component {
    state = {
        visible: false,
    }
    
    show = record => {
        this.setState({
            record,
            visible: true
        }, () => {
            this.loadData();
        });
    };

    close = () => {
        this.setState({ visible: false });
    };

    loadData = () => {
        const { investigationJdeContractId } = this.state.record;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeCodeEnclosure,
            data: {
                investigationJdeContractId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ data: res.data });
            }
        }
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
            const { id, name } = record;
            return <a onClick={e => this.downLoadFile(e, id)}>{name}</a>
        }
    }]

    getDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
                name: item.name
            })
        });

        return dataSource;
    }

    render () {
        const { record = {}, visible } = this.state;
        const { investigationJdeContractCode } = record;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.close}
                width="520px"
                footer={<Button type="primary" onClick={this.close}>关 闭</Button>}
            >
                <div>
                    <div style={{ marginBottom: 10 }}>JDE项目号：{investigationJdeContractCode}</div>
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDateSource()}
                        rowKey={record => record.index}
                        pagination={false}
                    />
                </div>
            </Modal>
        );
    }
}

export default LookAttachment;


// WEBPACK FOOTER //
// ./src/components/projectContract/childContract/LookAttachment.js